export default {
  // load prop item from local storage
  // returns undefined on error
  loadState(prop) {
    try {
      const serializedState = localStorage.getItem(prop);
      if (serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      return undefined;
    }
  },
  // save state in localstorage
  saveState(state, prop) {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem(prop, serializedState);
    } catch (err) {
      // Ignore write errors.
    }
  },
};
